import React, { Component } from 'react';
import { isPositiveNumber } from '../../helpers/GlobalFunctions';
import { promScoreMessages } from '../../helpers/messages';
import { PROMScoreTypes } from '../../containers/CaseDetails/constants';
import ErrorMsgBlockComponent from '../Error/ErrorMessageBlock';
class AddProms extends Component {
	constructor(props) {
		super(props);
		this.myFormRef = React.createRef();
		this.state = {
			scoreTypeDropdown: PROMScoreTypes[props.operativeProcedure.toLowerCase()],
			scoreType: '',
			scoreMin: 0,
			scoreMax: 100,
			selectedScoreObj: null
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.promScoreSave !== this.props.promScoreSave && this.props.promScoreSave) {
			this.resetForm();
		  }
	}

	/**
	 * @description Function to handle change in scoretype
	 * @memberof AddProms
	 */
	handleScoreTypeChange = (value) => {
		let { scoreTypeDropdown } = this.state;
		let scoreObj = scoreTypeDropdown.find(x => x.value === value);
		this.setState({ scoreType: value, selectedScoreObj: scoreObj })
		this.props.handleInputChange(value, 'scoreType')
	}

	/**
	 * @description Function to make sure only numbers are input
	 * @memberof AddProms
	 */
	checkNumeric = e => {
		const isValid = isPositiveNumber(e);
		if (!isValid) {
			e.preventDefault();
			return false;
		}
	}

	/**
	 * @description Function to reset the form
	 * @memberof AddProms
	 */
	resetForm = () => {
		this.myFormRef.reset();
		this.setState({ scoreType: '', selectedScoreObj: null })
		this.props.resetForm();
	}

	render() {
		const { handleInputChange, addPromScore, formErrors, promScoreSave, promsErrorMsg, getUserRoleType, onEnterPress, disableReset, isCustomScore, scoreFields, subScores, scoreValue } = this.props;
		const isDisabled = getUserRoleType.includes('rar');
		const { scoreTypeDropdown, scoreType, selectedScoreObj, scoreMin, scoreMax } = this.state;

		return <>
			<div className="proms-blocks add-prom-score" data-testid="add-prom-score">
				<div className={`proms-blocks-body ${isCustomScore ? 'custom-fields' : ''}`}>
					<div className="proms-block-title">Add PROM Score Entry</div>
					{promScoreSave === true ?
						<div className="proms-success-msg generic">
							<p>{promScoreMessages.saveData}</p>
						</div>
						: ''}
					{formErrors && formErrors.manualScoreOneRequired ?
						<p className="proms-error-msg generic">{formErrors.manualScoreOneRequired}</p>
						: ''}
					{promScoreSave === false && promsErrorMsg ? <ErrorMsgBlockComponent classListExplicit="proms-error-msg generic" errorObject={promsErrorMsg} /> : ''}
					<div className="form-wrap">
						<form onSubmit={onEnterPress} noValidate ref={(el) => this.myFormRef = el}>
							<div className="d-flex flex-column">
								<div className="fields-block">
									<div className="row">
										<div className="col-sm-6">
											<label className="custom-label">Score Type<span className="text-danger">*</span></label>
											<div className="form-group">
												<select data-testid="scoresType" id="scoresType" onChange={(e) => this.handleScoreTypeChange(e.target.value)} className="form-select" disabled={isDisabled}>
													<option value="">Select Score Type</option>
													{scoreTypeDropdown && scoreTypeDropdown.length && scoreTypeDropdown.map((score, index) => <option key={`score-type-${index}`} value={score.value}>{score.label}</option>)}
												</select>
												{formErrors && formErrors.scoreType ?
													<div className="proms-error-msg">
														<p>{formErrors.scoreType}</p>
													</div>
													: ''}
											</div>
										</div>
										<div className="col-sm-6">
											<label className="custom-label">Time Frame<span className="text-danger">*</span></label>
											<div className="form-group">
												<select id="timeFrame" data-testid="timeFrame" onChange={(e) => handleInputChange(e.target.value, 'timeFrame')} className="form-select" disabled={isDisabled}>
													<option value="">Select Time Frame</option>
													<option value="6 weeks" >6 Weeks</option>
													<option value="12 weeks">12 Weeks</option>
													<option value="6 months">6 Months</option>
													<option value="12 months">12 Months</option>
													<option value="2 years">2 Years</option>
												</select>
												{formErrors && formErrors.timeFrame ?
													<div className="proms-error-msg">
														<p>{formErrors.timeFrame}</p>
													</div>
													: ''}
											</div>
										</div>
									</div>

									<div className="row">
										{isCustomScore ?
											(scoreFields && scoreFields.length ? <>
												{scoreFields.map((x, i) => {
													return (<>
														{scoreFields.length % 2 && i === scoreFields.length - 1 ? <div className="col-sm-3" key={`score-buffer-div-${i + 1}`}></div> : ''}
														<div className="col-sm-6" key={`score-${i + 1}`}>
															<label className="custom-label">{x.label}</label>
															<div className="form-group">
																<input id={x.fieldName} onPaste={(e)=>e.preventDefault()}  type='number' min={x.min} max={x.max} autoComplete="off" value={!subScores || subScores[x.fieldName] === undefined ? '' : subScores[x.fieldName]}
																	onKeyDown={e => this.checkNumeric(e)} onChange={(e) => handleInputChange(e.target.value, x.fieldName)} className="form-control" disabled={isDisabled} />
																{formErrors && formErrors[x.fieldName] ?
																	<div className="proms-error-msg">
																		<p>{formErrors[x.fieldName]}</p>
																	</div>
																	: ''}
															</div>
														</div>
													</>)
												})}
											</>
												: '')
											: <>
												<div className="col-sm-3"></div>
												<div className="col-sm-6">
													<div className="d-flex align-items-center justify-content-between">
														<label className="custom-label">{scoreType === "PROMIS-Global" ? 'T-Score' : 'Score'}<span className="text-danger">*</span></label>
														{scoreType && ['KOOS JR.', 'HOOS JR.', 'PROMIS-Global'].indexOf(scoreType) > -1 ?
															<div className="proms-help-msg">
																<p>{promScoreMessages.scoreHelpText}</p>
															</div>
															: ''}
													</div>
													<div className="form-group">
														<div className="input-group">
															<input className="form-control" id="scoreValue" type="number" data-testid="scoreValue"
																min={selectedScoreObj ? selectedScoreObj.min : scoreMin} max={selectedScoreObj ? selectedScoreObj.max : scoreMax}
																autoComplete="off" value={scoreValue} disabled={isDisabled}
																onPaste={(e)=>e.preventDefault()}
																onKeyDown={e => this.checkNumeric(e)}
																onChange={(e) => handleInputChange(e.target.value, 'scoreValue')}
															/>
															{selectedScoreObj?.dataType === 'percentage' ? <>
																<div className="input-group-append">
																	<span className="input-group-text" id="scoreValueAppend">%</span>
																</div>
															</> : ''}
														</div>

														{formErrors && formErrors.scoreValue ?
															<div className="proms-error-msg">
																<p>{formErrors.scoreValue}</p>
															</div>
															: ''}
													</div>
												</div>
											</>}
									</div>
								</div>
								<div className="buttons-block">
									<div className="row">
										<div className="col-sm-12 mt-2 text-center">
											<button type="button" data-testid="addProms" className="btn btn-primary proms-btn-color me-2" disabled={isDisabled} onClick={addPromScore} id="addProms">Save</button>
											<button className="btn btn-primary proms-btn-color" disabled={disableReset || isDisabled} onClick={this.resetForm} id="resetProms" data-testid="resetProms">Clear</button>
										</div>
									</div>
								</div>
							</div>
						</form>

					</div>
				</div>
			</div>
		</>;
	}
}
export default AddProms;

